import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Package, ArrowLeft } from 'lucide-react';
import { Button } from './ui/button';
import './TrainingPages.css';

const POLLEN_BEE_IMG = "https://customer-assets.emergentagent.com/job_bee-booking/artifacts/k8zgjyqb_Pollen%20-%20bHyyve%20Mascot.png";

const MyOrders = () => {
  const navigate = useNavigate();

  return (
    <div className="training-page">
      {/* Banner */}
      <div className="training-banner">
        <div className="banner-content">
          <h1>My Orders</h1>
          <p>Track your marketplace orders and subscriptions</p>
        </div>
        <img src={POLLEN_BEE_IMG} alt="Pollen" className="banner-bee" />
      </div>

      {/* Empty State */}
      <div className="empty-state">
        <div className="empty-icon">
          <Package size={64} />
        </div>
        <h2>Orders Coming Soon</h2>
        <p>Order tracking will be available once the Marketplace launches. Check back soon!</p>
        <Button 
          className="back-btn"
          onClick={() => navigate('/yourhyyve')}
        >
          <ArrowLeft size={18} />
          Back to Dashboard
        </Button>
      </div>
    </div>
  );
};

export default MyOrders;
